import { render, staticRenderFns } from "./PresentationRequestForm.vue?vue&type=template&id=3680c214&"
import script from "./PresentationRequestForm.vue?vue&type=script&lang=js&"
export * from "./PresentationRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports